/* eslint-disable max-len */
import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.scss';

function NotFoundPage() {
  const history = useHistory();

  const handleOnClick = () => {
    history.replace('/');
  };

  return (
    <div className="notfound-page">
      <div className="notfound-content">
        <div className="notfound-code">404</div>
        <p className="notfound-message">
          The page you are looking for does not exist or has been moved.
        </p>
        <button type="button" className="notfound-btn" onClick={handleOnClick}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
          </svg>
          Back to lobby
        </button>
      </div>
    </div>
  );
}

export default NotFoundPage;
